module.exports = __webpack_public_path__ + "files/b04019fadd293da94129e04d9eea4c61.png";